// extracted by mini-css-extract-plugin
export var fadeIn = "_ls-1";
export var modalContent = "_ls-3";
export var overlay = "_ls-0";
export var popoverContent = "_ls-2";
export var results = "_ls-5";
export var searchInputWrapper = "_ls-4";